/**
 * This class describes websocket messages transported by Primus.
 */
export class WebsocketMessage {

  /**
   * Default constructor
   */
  constructor() {
    this.timeStamp = new Date();
    this.type = '';
    this.target = '';
    this.body = {};
    this.bodyType = '';
  }

  /**
   * The time when the message was sent by the server
   */
  timeStamp: Date;

  /**
   * The type of the action or event. For example can be add, delete, alert...
   */
  type: string;

  /**
   * The target (db table) to which the action or event is targeted. For example "target", "map_object"...
   */
  target: string;

  /**
   * The change entity, list of ids...
   */
  body: any;

  /**
   * The type of the body. For example "entity", "id_list"
   */
  bodyType: string;
}
